import {DomainEvent} from './DomainEvent';
import {MatchVideoElement} from '../resources/MatchVideoElement';

export class MatchVideoElementCreated extends DomainEvent<MatchVideoElement>  {}
